import { useContext, useEffect, useRef, useState } from "react";
import { showSuccessMessage } from "@beeldit/core/helpers/messagesHelper";
import { FloppyDisk } from "@phosphor-icons/react/dist/ssr";
import useUpdateSection from "./useUpdateSection";
import { DetailsByPageableActionContext } from "../detailsByPageable/DetailsByPageableActionContext";
import { DetailsActionContext } from "../details/DetailsActionContext";

function useUpdateSectionAction(): any {
  const sectionRef = useRef<HTMLDivElement>(null);
  const [sectionId, setSectionId] = useState<string | null>("");

  const {
    element: page,
    setElement: setPage,
    selectedLang,
  } = useContext(DetailsByPageableActionContext);
  const {
    element: page2,
    setElement: setPage2,
    selectedLang: selectedLang2,
  } = useContext(DetailsActionContext);

  const finalPage = page || page2;
  const finalSelectedLang = selectedLang || selectedLang2;
  const finalSetPage = page ? setPage : setPage2;

  /**
   * Form store success function definition
   */
  const onSuccessUpdate = (section: any) => {
    showSuccessMessage("successfull_action");
    // Actualizamos la section de la página con el mismo id
    let sectionIndex = finalPage.sections.findIndex(
      (s: any) => s.id === section.id
    );
    finalPage.sections[sectionIndex] = section;
    finalSetPage({ ...finalPage });
  };

  const updateSection = useUpdateSection();
  const updateSectionFunction = () => {
    // Comprobaciones defensivas para evitar errores en tiempo de ejecución
    if (!finalPage) {
      console.warn(
        "[useUpdateSectionAction] No hay página cargada para actualizar la sección"
      );
      return;
    }
    if (!finalPage.sections || !Array.isArray(finalPage.sections)) {
      console.warn(
        "[useUpdateSectionAction] La página no contiene un array de secciones válido",
        finalPage.sections
      );
      return;
    }
    if (!sectionId) {
      console.warn("[useUpdateSectionAction] sectionId no disponible todavía");
      return;
    }
    const sectionIndex = finalPage.sections.findIndex(
      (s: any) => s.id == sectionId
    );
    if (sectionIndex === -1) {
      console.warn(
        "[useUpdateSectionAction] No se encontró la sección con id",
        sectionId
      );
      return;
    }
    // Clonamos la sección para no mutar directamente la referencia (evita efectos colaterales)
    const section = {
      ...finalPage.sections[sectionIndex],
      lang: finalSelectedLang,
    };
    updateSection(finalPage.id, sectionId, section, onSuccessUpdate);
  };
  useEffect(() => {
    if (sectionRef.current) {
      // Encontrar el ancestro más cercano con el atributo `data-section-id`
      const ancestor = sectionRef.current.closest("[data-section-id]");
      if (ancestor) {
        console.log("Ancestro encontrado:", ancestor);
        let id = ancestor.getAttribute("data-section-id");
        setSectionId(id);
      }
    }
  }, []);

  const actionTemplate = (
    <div ref={sectionRef} className="d-inline">
      <button
        type="button"
        className="btn btn-link p-0"
        onClick={() => {
          updateSectionFunction();
        }}
        disabled={!sectionId}
        aria-label="Save section"
      >
        <FloppyDisk size={24} />
      </button>
    </div>
  );

  /** END EDIT FORM ACTION */

  return {
    actionTemplate,
  };
}

export default useUpdateSectionAction;
